import { render, staticRenderFns } from "./SpecificityTemplate.vue?vue&type=template&id=37817287&"
import script from "./SpecificityTemplate.vue?vue&type=script&lang=ts&"
export * from "./SpecificityTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports